import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiBaseUrl';

export interface OrdersValidationTotals {
  order_count: number;
  qty_mt: number;
  base_total: number;
  gst_total: number;
  gross_total: number;
  min_order_date: string | null;
  max_order_date: string | null;
}

export interface OrdersMonthlyRow {
  period: string;
  order_count: number;
  qty_mt: number;
  base_total: number;
  gst_total: number;
  gross_total: number;
}

export interface OrdersValidationResponse {
  from_date: string;
  to_date: string;
  state_filter: string | null;
  totals: OrdersValidationTotals;
  monthly: OrdersMonthlyRow[];
  by_state: Array<{
    state_label: string;
    order_count: number;
    qty_mt: number;
    base_total: number;
    gst_total: number;
    gross_total: number;
  }>;
  top_customers: Array<{
    customer_id: number;
    customer_name: string;
    state_label: string;
    order_count: number;
    qty_mt: number;
    gross_total: number;
  }>;
  by_category: Array<{
    category_name: string;
    order_count: number;
    qty_mt: number;
    gross_total: number;
  }>;
  by_status: Array<{
    order_status_id: number;
    status_label: string;
    order_count: number;
    gross_total: number;
  }>;
  state_options: string[];
}

export const fetchOrdersValidation = async (
  fromDate: string,
  toDate: string,
  state?: string
): Promise<OrdersValidationResponse> => {
  const base = getApiBaseUrl().replace(/\/?$/, '');
  const response = await axios.get<OrdersValidationResponse>(`${base}/orders-validation/analytics`, {
    params: {
      from_date: fromDate,
      to_date: toDate,
      state: state || undefined,
    },
  });
  return response.data;
};
